import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Aktenzeichen-Kürzel je Vorgangskategorie (z. B. VG, VER, BKA)
export default function CasePrefixesDialog({ open, onOpenChange, labels }) {
  const [p, setP] = useState({});
  const [defaults, setDefaults] = useState({});
  useEffect(() => {
    if (open) api.get("/vorgaenge/case-prefixes").then(({ data }) => { setP(data.prefixes); setDefaults(data.defaults); });
  }, [open]);
  const save = async () => {
    try { await api.put("/vorgaenge/case-prefixes", { prefixes: p }); toast.success("Kürzel gespeichert"); onOpenChange(false); }
    catch (e) { toast.error(e?.response?.data?.detail || "Fehler"); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto" data-testid="case-prefixes-dialog">
        <DialogHeader>
          <DialogTitle>Aktenzeichen-Kürzel</DialogTitle>
          <DialogDescription>Neue Vorgänge erhalten KÜRZEL-JJJJ-NNNN (z. B. VG-2026-0012). Bestehende Nummern bleiben erhalten und werden weiter erkannt.</DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5">
          {Object.keys(defaults).map((k) => (
            <div key={k} className="flex items-center gap-2 text-sm">
              <span className="flex-1">{labels[k] || k}</span>
              <Input value={p[k] || ""} maxLength={4} onChange={(e) => setP((x) => ({ ...x, [k]: e.target.value.toUpperCase() }))}
                className="w-20 h-8 font-mono uppercase" data-testid={`case-prefix-${k}`} />
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setP(defaults)}>Standard</Button>
          <Button onClick={save} className="bg-slate-900 hover:bg-slate-800" data-testid="case-prefixes-save">Speichern</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
